import { PageKey } from '~/constants/page';
import { apiAuthFeiShu } from '~/utils/feishu';

export default defineNuxtPlugin(() => {
  const route = useRoute();
  if (import.meta.client && route.name === PageKey.HOME) {
    // 延迟检查 h5sdk（避免异步加载未完成）
    const checkH5sdk = () => {
      if (window.h5sdk) {
        // 替换 alert 为日志输出
        apiAuthFeiShu();
      } else {
        // 重试机制（假设 h5sdk 可能异步加载，最多等待5秒）
        setTimeout(checkH5sdk, 500);
      }
    };
    checkH5sdk();
  }
});
